import React, { useEffect, useState } from 'react';
import { resolveApiAssetUrl } from '../lib/api';

const BitcoinMark = () => (
  <svg viewBox="0 0 32 32" width="100%" height="100%" role="img" aria-hidden="true">
    <circle cx="16" cy="16" r="16" fill="#F7931A" />
    <g fill="#fff">
      <rect x="10.4" y="5" width="1.9" height="6" rx="0.9" />
      <rect x="15.2" y="5" width="1.9" height="6" rx="0.9" />
      <rect x="10.4" y="21.5" width="1.9" height="6" rx="0.9" />
      <rect x="15.2" y="21.5" width="1.9" height="6" rx="0.9" />
    </g>
    <text
      x="16"
      y="22.6"
      textAnchor="middle"
      fontFamily="Arial, Helvetica, sans-serif"
      fontSize="17.5"
      fontWeight="700"
      fill="#fff"
    >
      B
    </text>
  </svg>
);

const TetherMark = () => (
  <svg viewBox="0 0 32 32" width="100%" height="100%" role="img" aria-hidden="true">
    <circle cx="16" cy="16" r="16" fill="#26A17B" />
    <g fill="#fff">
      <rect x="7" y="7.6" width="18" height="3.6" rx="0.8" />
      <rect x="14.2" y="7.6" width="3.6" height="17.6" rx="0.8" />
    </g>
    <ellipse
      cx="16"
      cy="13.8"
      rx="7.4"
      ry="2.9"
      fill="none"
      stroke="#fff"
      strokeWidth="1.7"
    />
  </svg>
);

const TronMark = () => (
  <svg viewBox="0 0 32 32" width="100%" height="100%" role="img" aria-hidden="true">
    <circle cx="16" cy="16" r="16" fill="#EF0027" />
    <path d="M4.8 8.4 27.2 12 15.2 27.6Z" fill="#fff" />
    <g stroke="#EF0027" strokeWidth="1.1" strokeLinejoin="round" fill="none">
      <path d="M4.8 8.4 15.7 15.8 27.2 12" />
      <path d="M15.7 15.8 15.2 27.6" />
    </g>
  </svg>
);

const EthereumMark = () => (
  <svg viewBox="0 0 32 32" width="100%" height="100%" role="img" aria-hidden="true">
    <circle cx="16" cy="16" r="16" fill="#627EEA" />
    <g fill="#fff">
      <path d="M16 4v9.1l7.5 3.4Z" fillOpacity="0.6" />
      <path d="M16 4 8.5 16.5 16 13.1Z" />
      <path d="M16 22.2v5.8l7.5-10.1Z" fillOpacity="0.6" />
      <path d="M16 28v-5.8L8.5 17.9Z" />
      <path d="M16 20.8l7.5-4.3-7.5-3.4Z" fillOpacity="0.4" />
      <path d="M8.5 16.5l7.5 4.3v-7.7Z" fillOpacity="0.8" />
    </g>
  </svg>
);

const BnbMark = () => (
  <svg viewBox="0 0 32 32" width="100%" height="100%" role="img" aria-hidden="true">
    <circle cx="16" cy="16" r="16" fill="#F3BA2F" />
    <g fill="#fff">
      <path d="M16 5.4 19 8.4 16 11.4 13 8.4Z" />
      <path d="M8.4 13 11.4 16 8.4 19 5.4 16Z" />
      <path d="M23.6 13 26.6 16 23.6 19 20.6 16Z" />
      <path d="M16 20.6 19 23.6 16 26.6 13 23.6Z" />
      <path d="M16 12.6 19.4 16 16 19.4 12.6 16Z" />
    </g>
  </svg>
);

const SolanaMark = () => (
  <svg viewBox="0 0 32 32" width="100%" height="100%" role="img" aria-hidden="true">
    <circle cx="16" cy="16" r="16" fill="#0B0B14" />
    <g>
      <path d="M10.4 10.2h14l-3.4 3.2h-14Z" fill="#9945FF" />
      <path d="M7 16.1h14l3.4 3.2h-14Z" fill="#7A67E8" />
      <path d="M10.4 22h14l-3.4 3.2h-14Z" fill="#14F195" />
    </g>
  </svg>
);

const LitecoinMark = () => (
  <svg viewBox="0 0 32 32" width="100%" height="100%" role="img" aria-hidden="true">
    <circle cx="16" cy="16" r="16" fill="#345D9D" />
    <text
      x="16"
      y="23"
      textAnchor="middle"
      fontFamily="Arial, Helvetica, sans-serif"
      fontSize="18"
      fontWeight="700"
      fill="#fff"
    >
      Ł
    </text>
  </svg>
);

const BankMark = () => (
  <svg viewBox="0 0 32 32" width="100%" height="100%" role="img" aria-hidden="true">
    <rect width="32" height="32" rx="9" fill="#1D4ED8" />
    <g fill="#fff">
      <path d="M16 5.6 26.4 11v2.2H5.6V11Z" />
      <rect x="9" y="15" width="2.7" height="7.6" rx="0.6" />
      <rect x="14.65" y="15" width="2.7" height="7.6" rx="0.6" />
      <rect x="20.3" y="15" width="2.7" height="7.6" rx="0.6" />
      <rect x="6.6" y="24.2" width="18.8" height="2.6" rx="1.1" />
    </g>
  </svg>
);

// Sağlayıcı cüzdanı (Payurus/CepPay gibi): ne banka ne kripto — hedef bir
// cüzdan numarasıdır.
const WalletMark = () => (
  <svg viewBox="0 0 32 32" width="100%" height="100%" role="img" aria-hidden="true">
    <rect width="32" height="32" rx="9" fill="#7C3AED" />
    <g fill="#fff">
      <path d="M7 10.5a2.5 2.5 0 0 1 2.5-2.5h11.2a1.3 1.3 0 0 1 0 2.6H9.9a.9.9 0 0 0 0 1.8h13.3A1.8 1.8 0 0 1 25 14.2v8A2.8 2.8 0 0 1 22.2 25H9.8A2.8 2.8 0 0 1 7 22.2Z" />
    </g>
    <circle cx="20.6" cy="18.2" r="1.7" fill="#7C3AED" />
  </svg>
);

// Kredi kartı akışları (Wizkasa CARD, Hera kart-kart/kredi kartı, UltraPay 10,
// Link Havale card). Hepsi `method_type: 'bank'` kaydedilir — hedef sonuçta bir
// banka hesabıdır — ama oyuncu kartıyla öder ve listede havaleden ayrılmalıdır.
const CardMark = () => (
  <svg viewBox="0 0 32 32" width="100%" height="100%" role="img" aria-hidden="true">
    <rect width="32" height="32" rx="9" fill="#0E7490" />
    <rect x="5.4" y="9" width="21.2" height="14" rx="2.6" fill="#fff" />
    <rect x="5.4" y="12.3" width="21.2" height="3.2" fill="#0E7490" />
    <rect x="8.2" y="18.1" width="6.6" height="2.2" rx="1.1" fill="#0E7490" />
    <rect x="16.6" y="18.1" width="3.2" height="2.2" rx="1.1" fill="#0E7490" />
  </svg>
);

// Kendi çizimi olmayan para birimleri sembolünü marka renginin üstünde
// gösterir; böylece listedeki her kripto ayırt edilebilir bir ikon alır.
const SymbolMark = ({ symbol, accent }) => {
  const label = (symbol || 'COIN').slice(0, 4);
  return (
    <svg viewBox="0 0 32 32" width="100%" height="100%" role="img" aria-hidden="true">
      <circle cx="16" cy="16" r="16" fill={accent || '#4B5563'} />
      <text
        x="16"
        y={label.length > 3 ? 19.4 : 20.2}
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize={label.length > 3 ? 9 : 11.5}
        fontWeight="700"
        fill="#fff"
      >
        {label}
      </text>
    </svg>
  );
};

// Ödeme markasının rozeti: renkli kare + baş harfler. Kripto ikonları daire
// olduğu için kare bilinçlidir — aynı listede iki ayrı şey (para birimi ve
// ödeme yöntemi) çizilir ve şekil ikisini birbirinden ayırır.
const BrandMark = ({ symbol, accent, ink }) => {
  const label = (symbol || '?').slice(0, 3);
  return (
    <svg viewBox="0 0 32 32" width="100%" height="100%" role="img" aria-hidden="true">
      <rect width="32" height="32" rx="9" fill={accent || '#4B5563'} />
      <text
        x="16"
        y={label.length > 2 ? 20.2 : 20.8}
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize={label.length > 2 ? 11 : 13}
        fontWeight="700"
        fill={ink || '#fff'}
      >
        {label}
      </text>
    </svg>
  );
};

const BRANDS = {
  BTC: { name: 'Bitcoin', accent: '#F7931A', Mark: BitcoinMark },
  USDT: { name: 'Tether', accent: '#26A17B', Mark: TetherMark },
  TRX: { name: 'Tron', accent: '#EF0027', Mark: TronMark },
  ETH: { name: 'Ethereum', accent: '#627EEA', Mark: EthereumMark },
  BNB: { name: 'BNB', accent: '#F3BA2F', Mark: BnbMark },
  SOL: { name: 'Solana', accent: '#14F195', Mark: SolanaMark },
  LTC: { name: 'Litecoin', accent: '#345D9D', Mark: LitecoinMark },
  BANK: { name: 'Banka Havale/FAST', accent: '#3B82F6', Mark: BankMark },
  WALLET: { name: 'Sağlayıcı Cüzdanı', accent: '#7C3AED', Mark: WalletMark },
};

// Çizimi olmayan para birimlerinin marka renkleri.
const ASSET_ACCENTS = {
  USDC: '#2775CA',
  XRP: '#23292F',
  DOGE: '#C2A633',
  ADA: '#0033AD',
  AVAX: '#E84142',
  MATIC: '#8247E5',
  DOT: '#E6007A',
  SHIB: '#F00500',
  DAI: '#F5AC37',
  TON: '#0098EA',
  BCH: '#8DC351',
  XLM: '#14B6E7',
  ETC: '#328332',
  LINK: '#2A5ADA',
  ATOM: '#2E3148',
  NEAR: '#111111',
  APT: '#1B1F23',
  ARB: '#213147',
  OP: '#FF0420',
  PEPE: '#3D8130',
  FTM: '#1969FF',
  ALGO: '#000000',
  XMR: '#FF6600',
};

const CRYPTO_RULES = [
  ['USDT', /USDT|TETHER/],
  ['BTC', /BTC|BITCOIN/],
  ['ETH', /\bETH\b|ETHEREUM|ERC.?20/],
  ['TRX', /TRX|TRON|TRC.?20/],
  ['BNB', /BNB|BEP.?20|BINANCE|SMART CHAIN/],
  ['SOL', /\bSOL\b|SOLANA/],
  ['LTC', /\bLTC\b|LITECOIN/],
];

// **Hiçbir ödeme sağlayıcısı yöntem logosu döndürmez.** UltraPay'in dört ucu
// (`/deposit`, `/withdraws`, `/status/control`, `/company/balance`) yalnızca
// para hareketi taşır, katalog koda gömülüdür; Wizkasa, Hera ve Link Havale de
// yöntemin yalnızca adını verir. Logo bu yüzden ada göre burada çözülür —
// yoksa UltraPay'in on bir `iban` yöntemi (Papara, Paycell, Tosla, Fups, Para
// Kolay …) `method_type: 'bank'` kaydedildiği için listede **aynı mavi banka
// ikonuyla** görünür ve oyuncu seçtiği yöntemi ikondan ayırt edemez.
//
// Yönetici gerçek logoyu panelden yükleyebilir (`icon_url`, Ödeme Yöntemleri →
// yöntem → logo) ve o her zaman öndedir; buradaki rozet yalnızca yüklenmemiş
// olanın yerini tutar. **Yeni bir sağlayıcı yöntemi eklerken bu listeye de bir
// satır yazın**, yoksa yöntem yine jenerik ikona düşer.
const PAYMENT_BRANDS = [
  { key: 'CARD', match: /KRED[İI]\s*KART|KART\s*-\s*KART|CREDIT\s*CARD/, name: 'Kredi Kartı', Mark: CardMark },
  { key: 'PAPARA', match: /PAPARA/, name: 'Papara', accent: '#6E2CF4' },
  { key: 'PAYCELL', match: /PAYCELL/, name: 'Paycell', accent: '#FFC72C', ink: '#1F2937' },
  { key: 'TOSLA', match: /TOSLA/, name: 'Tosla' },
  { key: 'FUPS', match: /FUPS/, name: 'Fups' },
  { key: 'PARAKOLAY', match: /PARA\s*KOLAY/, name: 'Para Kolay' },
  { key: 'MONEYTOLIA', match: /MONEY\s*TOLIA/, name: 'Money Tolia' },
  { key: 'AHLPAY', match: /AHL\s*PAY/, name: 'Ahlpay' },
  { key: 'HAYHAY', match: /HAYHAY/, name: 'Hayhay' },
  { key: 'HADIPAY', match: /HAD[İI]\s*PAY/, name: 'Hadi Pay' },
  { key: 'JOYPAYZ', match: /JOY\s*PAYZ/, name: 'JoyPayz' },
  { key: 'YESOD', match: /YESOD/, name: 'Yesod' },
  { key: 'CEPPAY', match: /CEP\s*PAY/, name: 'CepPay' },
  // Wizkasa'nın "Mobil Cüzdan" satırı da `bank` kaydedilir; hedefi bir cüzdan
  // olduğu için banka değil cüzdan ikonu alır.
  { key: 'WALLET', match: /MOB[İI]L\s*C[ÜU]ZDAN/, name: 'Mobil Cüzdan', Mark: WalletMark },
];

// Sağlayıcı eki ada her zaman yazılır ("Papara (UltraPay)"); marka aranmadan
// önce düşürülür, yoksa monogram sağlayıcının baş harfini alırdı.
const brandLabel = (name) => String(name || '')
  .replace(/\s*\([^)]*\)\s*/g, ' ')
  .trim();

const brandInitials = (label) => {
  const tokens = String(label || '')
    .replace(/[^\p{L}\p{N}\s]/gu, ' ')
    .split(/\s+/)
    .filter(Boolean);
  if (!tokens.length) return '?';
  if (tokens.length === 1) return tokens[0].slice(0, 2).toUpperCase();
  return (tokens[0][0] + tokens[1][0]).toUpperCase();
};

// Marka rengi bilinmiyorsa addan türetilir: amaç markanın gerçek rengini
// çizmek değil — uydurulmuş bir renk yanlış bir logo gibidir — her yönteme
// ekranın her yerinde aynı kalan ayırt edilebilir bir rozet vermektir
// (takım rozetindeki yaklaşımın aynısı).
const derivedAccent = (text) => {
  const value = String(text || '');
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) % 360;
  }
  return `hsl(${hash} 48% 34%)`;
};

const resolveNamedBrand = (name) => {
  const label = brandLabel(name);
  if (!label) return null;
  const haystack = label.toUpperCase();
  const entry = PAYMENT_BRANDS.find((item) => item.match.test(haystack));
  if (!entry) return null;
  return {
    key: entry.key,
    name: entry.name,
    accent: entry.accent || derivedAccent(entry.key),
    ink: entry.ink,
    symbol: entry.symbol || brandInitials(entry.name),
    Mark: entry.Mark || BrandMark,
  };
};

export const resolvePaymentBrand = (method = {}) => {
  const methodType = String(method.method_type || '').trim().toLowerCase();
  // Kripto satırında ikon para biriminden gelir; ad üzerinden marka aramak
  // "USDT (TRC20)" satırını bir ödeme markasına benzetebilirdi.
  if (methodType !== 'crypto' && !method.asset) {
    const named = resolveNamedBrand(method.name);
    if (named) return named;
  }

  if (methodType === 'bank' || method.type === 'havale') {
    return { key: 'BANK', ...BRANDS.BANK };
  }
  // Cüzdan yöntemlerinde `asset` boştur; kripto kuralları çalıştırılırsa
  // yöntem adından rastgele bir sembol üretilirdi.
  if (methodType === 'wallet') {
    return { key: 'WALLET', ...BRANDS.WALLET };
  }

  // Para birimi kodu tanımlıysa ikon doğrudan ondan gelir; ad veya ağ
  // metnindeki rastlantısal eşleşmeler devreye girmez.
  const asset = String(method.asset || '').trim().toUpperCase();
  if (BRANDS[asset]) {
    return { key: asset, ...BRANDS[asset] };
  }
  if (asset) {
    return {
      key: asset,
      name: method.asset_name || method.name || asset,
      accent: ASSET_ACCENTS[asset] || '#4B5563',
      symbol: asset,
      Mark: SymbolMark,
    };
  }

  const haystack = [method.name, method.network, method.asset_name]
    .filter(Boolean)
    .join(' ')
    .toUpperCase();

  const matched = CRYPTO_RULES.find(([, pattern]) => pattern.test(haystack));
  if (matched) {
    const [key] = matched;
    return { key, ...BRANDS[key] };
  }

  return {
    key: 'GENERIC',
    name: method.name || 'Kripto',
    accent: '#4B5563',
    symbol: (method.name || '').replace(/[^A-Za-z]/g, '').toUpperCase(),
    Mark: SymbolMark,
  };
};

const PaymentMethodLogo = ({ method, size = 44, className = '' }) => {
  const brand = resolvePaymentBrand(method);
  const { Mark } = brand;
  const [customImageFailed, setCustomImageFailed] = useState(false);

  useEffect(() => {
    setCustomImageFailed(false);
  }, [method?.icon_url]);

  const customIcon = method?.icon_url && !customImageFailed;

  return (
    <span
      className={`pm-logo-shell ${className}`.trim()}
      style={{ width: size, height: size }}
      title={method?.name || brand.name}
    >
      {customIcon ? (
        <img
          src={resolveApiAssetUrl(method.icon_url)}
          alt=""
          className="h-full w-full object-contain"
          onError={() => setCustomImageFailed(true)}
        />
      ) : (
        <Mark symbol={brand.symbol} accent={brand.accent} ink={brand.ink} />
      )}
    </span>
  );
};

export default PaymentMethodLogo;
